import type { BreakpointsOptions } from '@mui/system';

enum Breakpoint {
  XS = 0,
  SM = 720,
  MD = 900,
  LG = 1200,
  XL = 1536,
}
const breakpoints: BreakpointsOptions = {
  values: {
    xs: Breakpoint.XS,
    sm: Breakpoint.SM,
    md: Breakpoint.MD,
    lg: Breakpoint.LG,
    xl: Breakpoint.XL,
  },
};

export { breakpoints, Breakpoint };
